import { render, staticRenderFns } from "./PayBoxClose.vue?vue&type=template&id=27532995&scoped=true&"
import script from "./PayBoxClose.vue?vue&type=script&lang=js&"
export * from "./PayBoxClose.vue?vue&type=script&lang=js&"
import style0 from "./PayBoxClose.vue?vue&type=style&index=0&id=27532995&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27532995",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27532995')) {
      api.createRecord('27532995', component.options)
    } else {
      api.reload('27532995', component.options)
    }
    module.hot.accept("./PayBoxClose.vue?vue&type=template&id=27532995&scoped=true&", function () {
      api.rerender('27532995', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box-close/PayBoxClose.vue"
export default component.exports